import {Button, Card, Chip, Grid, Stack, Typography, useTheme} from "@mui/joy";
import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {motion} from "motion/react";
import GuestNavbar from "../../components/Layout/GuestNavbar";
import PricingCardComponent from "../../components/Subscription/PricingCardComponent";
import {useTranslation} from "react-i18next";
import LoadingPageComponent from "../../components/Loading/LoadingPageComponent";
import {DEFAULT_SUBSCRIPTION_PLANS} from "../../models/subscription";
import {useAsync} from "../../hooks/useAsyncResult";
import {getSubscriptions} from "../../services/api/subscription";
import LoadingError from "../../components/Error/LoadingError";

const Pricing = () => {
    const {t} = useTranslation()
    const subscriptionPlansAsyncResult=useAsync(getSubscriptions)

    useEffect(() => {
        subscriptionPlansAsyncResult.execute()
    }, [])

    return (
        <Stack sx={{minHeight: "100vh", overflowX: "hidden"}}>
            <GuestNavbar active="pricing"/>

            <Stack
                paddingX={{xs: 2, sm: 4, lg: 6}}
                paddingY={{xs: 4, md: 6}}
                gap={4}
                alignItems="center">
                <motion.div
                    initial={{opacity: 0, y: 16}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.4}}>

                    <Typography textAlign={"center"} level="h1"
                                sx={{fontSize: {xs: "1.75rem", md: "2.25rem"}, marginBottom: 1}}>
                        {t("pricingTitle")}
                    </Typography>
                    <Typography textAlign={"center"} level="body-lg" textColor="neutral.600">
                        {t("pricingDescription")}
                    </Typography>
                </motion.div>

                {!subscriptionPlansAsyncResult.isSuccess && !subscriptionPlansAsyncResult.loading && <LoadingError label={t("pricingLabel")} onRetry={subscriptionPlansAsyncResult.execute} />}

                {subscriptionPlansAsyncResult.loading?
                    <LoadingPageComponent label={t("pricingTitle")}/>:
                    <Grid container spacing={2} sx={{maxWidth: 1200, width: "100%"}}>
                    {subscriptionPlansAsyncResult.payload?.map((plan, i) => (
                        <Grid xs={12} sm={6} md={4} key={plan.id ?? i}>
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                animate={{opacity: 1, y: 0}}
                                transition={{duration: 0.4, delay: i * 0.08}}>
                                <PricingCardComponent subscription={plan}/>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>}

                <Typography level="body-sm" textColor="neutral.500">
                    {t("pricingFooterCallToActionText")}
                    <Link to={"/contact"}
                          style={{textDecoration: "none"}}>
                        <Typography color={"primary"}>
                            <b>
                                {t("pricingFooterCallToActionLabel")}
                            </b>
                        </Typography>
                    </Link>
                </Typography>
            </Stack>
        </Stack>
    )
}

export default Pricing;
